/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/no-unsafe-function-type */
/* eslint-disable   @typescript-eslint/no-empty-function */

import {
  Component,
  DestroyRef,
  inject,
  input,
  OnDestroy,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor, FormControl, FormGroup,
  FormsModule,
  NG_VALIDATORS, NG_VALUE_ACCESSOR,
  ReactiveFormsModule, ValidationErrors, ValidatorFn,
  Validators
} from '@angular/forms';
import { User } from '@shared/interfacres/user';
import { Subscription } from 'rxjs';
import { MatAutocompleteTrigger, MatOption } from '@angular/material/autocomplete';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserDataFormValue } from '@shared/helpers/user-form-to-payload';
import { MatSelect } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';


export const oneLinkValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const website = control.get('website');
  const instagram = control.get('instagram');
  const facebook = control.get('facebook');

  if (website?.value !== '' || instagram?.value !== '' || facebook?.value !== '') {
    return null; // Passwords match or controls are not found
  }
  return { 'noSocials': true }; // Passwords do not match
};

// export interface Temp {
//   id: number;
//   name: string;
//   selected: boolean;
// }

const urlRegExp = /^(https?):\/\/(?:www\.)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?:[^\s]*)?$/;
const mediaRegExp = /^(?=.*[@.]).*$/;

@Component({
  selector: 'app-user-data',
  templateUrl: './user-data.html',
  styleUrls: ['./user-data.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatOption,
    MatSelect,
    MatTooltip
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: UserData
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: UserData
    },
  ]
})
export class UserData implements OnDestroy, ControlValueAccessor {
  // toppingList: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];
  // toppings = new FormControl('');
  // tempsList: Temp[] = [{
  //   id: 1,
  //   name: 'Temp 1',
  //   selected: false
  // }, {
  //   id: 2,
  //   name: 'Temp 2',
  //   selected: false
  // }, {
  //   id: 3,
  //   name: 'Temp 3',
  //   selected: false
  // }, {
  //   id: 4,
  //   name: 'Temp 4',
  //   selected: false
  // }];
  // selectedTemps: Temp[] = new Array<Temp>();


  // optionClicked(event: Event, user: Temp) {
  //   console.log('user-data.ts => optionClicked: ', user);
  //   event.stopPropagation();
  //   this.toggleSelection(user);
  // }
  //
  // toggleSelection(user: Temp) {
  //   console.log('user-data.ts => toggleSelection: ', user);
  //   user.selected = !user.selected;
  //   if (user.selected) {
  //     this.selectedTemps.push(user);
  //   } else {
  //     const i = this.selectedTemps.findIndex(value => value.name === user.name);
  //     this.selectedTemps.splice(i, 1);
  //   }
  //
  //   this.form.controls.temps.setValue(this.selectedTemps);
  // }


  user = input<User | null>(null);
  // countries = input<CountyItem[]>([]);
  performanceTypes = input<string[]>([]);

  showLabels = input<boolean>(false);

  private destroyRef = inject(DestroyRef);


  form = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    stageName: new FormControl('', [Validators.required]),
    // stageName2: new FormControl(''),
    // stageName3: new FormControl(''),
    // performanceType: new FormControl('', [Validators.required]),
    performanceType: new FormControl([''], [Validators.required]),
    weeklyPerformances: new FormControl(null, [Validators.required, Validators.min(1)]),
    website: new FormControl('', [Validators.pattern(urlRegExp)]),
    instagram: new FormControl('', [Validators.pattern(mediaRegExp)]),
    facebook: new FormControl('', [Validators.pattern(mediaRegExp)]),
    // twitter: new FormControl(''),
    performanceLocations1: new FormControl('', [Validators.required]),
    performanceLocations2: new FormControl(''),
    performanceLocations3: new FormControl(''),

    // temps: new FormControl<Temp[]>([])

  },
    { validators: oneLinkValidator }
  );

  onTouched: Function = () => {};
  onChangeSubs: Subscription[] = [];

  ngOnDestroy() {
    for (const sub of this.onChangeSubs) {
      sub.unsubscribe();
    }
  }

  openPanel(trigger: MatAutocompleteTrigger): void {
    trigger.openPanel();
  }

  registerOnChange(onChange: any) {
    const sub = this.form.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((ch) => {
        onChange(ch)
      });
    this.onChangeSubs.push(sub);
  }

  registerOnTouched(onTouched: Function) {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean) {
    if (disabled) {
      this.form.disable();
    }
    else {
      this.form.enable();
    }
  }

  writeValue(value: any) {
    if (value) {
      this.form.setValue(value, {emitEvent: false});
    }
  }

  displayPhone(item: {emoji: string; dial_code: string}): string {
    return item?.emoji + item?.dial_code || '';
  }

  // displayFn(item: {id: number; title: string}): string {
  //   return item?.title || '';
  // }
  // displayFn(value: Temp[] | string): string {
  //   let displayValue = '';
  //   if (Array.isArray(value)) {
  //     value.forEach((user, index) => {
  //       if (index === 0) {
  //         displayValue = user.name;
  //       } else {
  //         displayValue += ', ' + user.name ;
  //       }
  //     });
  //   } else {
  //     displayValue = value;
  //   }
  //   return displayValue;
  // }

  validate() {
    if (this.form.valid) {
      return null;
    }


    let errors : any = this.form.errors;

    errors = this.addControlErrors(errors, 'firstName');
    errors = this.addControlErrors(errors, 'lastName');
    errors = this.addControlErrors(errors, 'performanceLocations1');
    errors = this.addControlErrors(errors, 'stageName');
    errors = this.addControlErrors(errors, 'performanceType');
    errors = this.addControlErrors(errors, 'weeklyPerformances');
    errors = this.addControlErrors(errors, 'website');
    errors = this.addControlErrors(errors, 'facebook');
    errors = this.addControlErrors(errors, 'instagram');

    return errors;
  }

  addControlErrors(allErrors: any, controlName: keyof UserDataFormValue) {
    const errors = {...allErrors};

    const controlErrors = this.form.controls[controlName].errors;

    if (controlErrors) {
      errors[controlName] = controlErrors;
    }

    return errors;
  }

}
